export default function () {
  let langSelect = document.getElementById('lang-switcher');

  if(langSelect) {
    langSelect.addEventListener('change', (e) => {
      let val = e.target.value;
      let link = document.querySelector(`a[hreflang=${val}]`).dataset.lang;

      window.location.assign(link);
    });
  }

}
